import React from 'react'

const VariableTextTableData = ({
	text,
	setText,
	disabled,
	containsValidText = true,
}) => {
	const onInputChange = (e) => {
		setText(e.target.value)
	}

	return (
		<td>
			<input
				className='variableTableInput'
				type='text'
				value={text}
				onInput={onInputChange}
				disabled={disabled}
				style={{ border: !containsValidText ? 'red 2px solid' : 'none', width: '95%' }}
			/>
		</td>
	)
}

export default VariableTextTableData
